import { useConfig as hook } from '@eika-infrastruktur/config-provider';
import nbTranslations from './translations/nbTranslations-config';
import nnTranslations from './translations/nnTranslations-config';
// Used in legacy
export const defaultFormTexts = {
    header: 'Kontakt meg',
    ingressText: 'Send inn skjemaet under så vil vi, innen utgangen av neste arbeidsdag, ta kontakt for en prat i banken eller per telefon.',
    name: 'Navn',
    email: 'E-post',
    phone: 'Telefon',
    send: 'Kontakt meg',
    gdprText: 'Etter at vi har kontaktet deg blir informasjonen du oppgir her slettet etter gjeldende rutiner hos oss. Dersom du ønsker informasjon om dine rettigheter rundt blant annet sletting, innsyn, klage og samtykke finner du det på vår ',
    nameTooLong: 'Navnet er for langt.',
    fillName: 'Vennligst oppgi fullt navn.',
    fillContact: 'Vennligst oppgi kontaktinformasjon.',
    pendingText: 'Sender beskjed til rådgiver...',
    registerErrorHeader: 'Noe gikk galt.',
    registerErrorText: 'Prøv igjen senere.',
    takk: 'Takk!',
    buttonTextOk: 'Ok',
    registerSuccessHeader: 'Takk',
    registerSuccessText: 'Din henvendelse er mottatt, og du hører fra oss.',
};
const defaultTexts = {
    header: 'Ønsker du rådgivning?',
    knappText: 'Send',
    checkboxHeader: 'Hva gjelder det?',
    textAreaHeader: 'Beskriv kort hva det gjelder',
    ingressText: 'Bankens rådgivere er her for å hjelpe deg. Vi kontakter deg innen x virkedager.',
    pendingText: 'Sender beskjed til rådgiver...',
    registerErrorHeader: 'Noe gikk galt.',
    registerErrorText: 'Prøv igjen senere.',
    takk: 'Takk!',
    buttonTextOk: 'Ok',
    registerSuccessHeader: 'Takk',
    registerSuccessText: 'Din henvendelse er mottatt, og du hører fra oss innen X virkedager.',
    confirmTextHeader: 'Vennligst bekreft at du ønsker at rådgiver skal ringe deg.',
    confirmButtonText: 'Bekreft',
    cancleButtonText: 'Avbryt',
    subjectRequiredText: 'Vennligst besvar hva henvendelsen gjelder.',
    otherInformationText: 'Ved innsending av dette skjemaet søker du om avdragsfrihet på alle dine boliglån. Du vil bli kontaktet av banken når saken er behandlet.',
    avdragsfrihet: {
        dropDownPretext: 'Søk om avdragsfrihet',
        dropDownLabel: 'Årsak til søknad om avdragsfrihet:',
        stepSelectLabel: 'Hvor lenge trenger du avdragsfrihet?',
        reasonRequiredText: 'Vennligst velg årsak.',
        textRequiredText: 'Vennligst beskrive hvorfor du har behov for avdragsfrihet.',
    },
    name: 'Navn',
    email: 'E-post',
    phone: 'Telefon',
    send: 'Kontakt meg',
    gdprText: 'Etter at vi har kontaktet deg blir informasjonen du oppgir her slettet etter gjeldende rutiner hos oss. Dersom du ønsker informasjon om dine rettigheter rundt blant annet sletting, innsyn, klage og samtykke finner du det på vår ',
    nameTooLong: 'Navnet er for langt.',
    emailTooLong: 'Mailadressen er for lang.',
    phoneNumberTooLong: 'Telefonnummeret er for langt.',
    fillName: 'Vennligst oppgi fullt navn.',
    fillContact: 'Vennligst oppgi kontaktinformasjon.',
};
export const defaultConfig = {
    siteLang: 'nb',
    translations: {
        nb: nbTranslations,
        nn: nnTranslations,
    },
    // Note: the optional bankregnr is a workaround for a bug!!! Removing it makes typescript scream in src/index.tsx
    bankregnr: '4605',
    overrideBnr: null,
    featureToggles: {
        showFeeWarning: true,
        enableAnonymousFormAntiSpam: true,
        enableMoveBSU: true,
        enableNewBankId: true,
        enableNewLoan: true,
        enableMoveASK: true,
        enableMoveInsurance: true,
        enableConsolidateCredit: true,
        enableCreditCard: true,
    },
    links: {
        redirectURL: {
            url: '/oversikt/kjop',
        },
        loanLink: { url: '/nettbank/laan' },
        bannerLink: {
            url: '/avdragsfrihet',
        },
        contactLink: {
            url: '/rådgivning',
        },
        gdprURL: {
            url: '/personvern-cookies',
            text: 'personvernside.',
        },
        frontpageLink: {
            url: '/nettbank',
        },
        secureCommunicationLink: {
            url: '/nettbank/Profil/sikker-kommunikasjon',
        },
    },
    numberOfDays: '5 virkedager',
    subjects: {},
    avdragsfrihetSubjects: {},
    numbers: {
        textAreaTextLength: 50,
        freeTextMaxLength: 250,
    },
    texts: defaultTexts,
    meldinteresseconfig: {
        jseventname: 'sitecore-meld-interesse-js-event',
        produktkode: 'M16',
        translations: {
            nb: {
                title: 'Spør oss om pris på bilforsikring',
                description: 'Fyll ut opplysningene så kontakter vi deg for en uforpliktende prat og konkret tilbud på denne forsikringen.',
                submitbuttonname: 'Kontakt meg',
            },
            nn: {
                title: 'Spør oss om pris på bilforsikring',
                description: 'Fyll ut opplysningane så tek vi kontakt med deg for ein uforpliktande prat og konkret tilbod på denne forsikringa.',
                submitbuttonname: 'Kontakt meg',
            },
        },
        kontakttlf: '915 03 850',
        activatecheckbox: true,
        activateandhidecheckbox: false,
    },
};
export const defaultFormConfig = {
    ...defaultConfig,
    texts: { ...defaultTexts, ...defaultFormTexts },
};
function createHook() {
    return () => hook();
}
export const useConfig = createHook();
//# sourceMappingURL=data:application/json;base64,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